import React from 'react';
import { Link } from 'react-router-dom';
import { preventOrphans, parseMarkdown } from '../utils/textUtils';

// Assets base URL
const ASSETS_BASE_URL = 'https://dyararts.com';

function NewsPage({ newsData, assetsData }) {
  // Helper function to get thumbnail URL from artwork ID
  const getThumbnailUrl = (artworkId) => {
    if (!artworkId || !assetsData) return null;
    const artwork = assetsData.find(asset => asset['artwork-id'] === artworkId);
    return artwork?.thumbnail ? `${ASSETS_BASE_URL}${artwork.thumbnail}` : null;
  };
  return (
    <div className="page-container">
      <div className="page-content">
        
        <div className="page-section-wrapper">
          <div className="page-section-header">
            <Link to="/" className="btn-nav">←</Link>
            <h1>News <span>& Updates</span></h1>
          </div>
          
          {newsData && newsData.length > 0 ? (
            <div className="news-feed-page">
              {newsData.map((item, index) => {
                const thumbnailUrl = getThumbnailUrl(item.thumbnail);
                
                const newsItemContent = (
                  <>
                    {/* Row 1: Category and Date */}
                    <div className="news-item-meta">
                      {item.Category && (
                        <div className="news-category">{item.Category}</div>
                      )}
                      {item.Date && (
                        <div className="news-date">
                          {(() => {
                            // Parse date like "Nov 4, 2025" or "Oct 1, 2024"
                            const dateMatch = item.Date.match(/^(\w+)\s+(\d+),\s+(\d+)$/);
                            if (dateMatch) {
                              const [, month, day, year] = dateMatch;
                              return (
                                <>
                                  {month} {day}, {year}
                                </>
                              );
                            }
                            return item.Date;
                          })()}
                        </div>
                      )}
                    </div>
                    
                    {/* Row 2: Headline */}
                    {item.Headline && (
                      <h4 className="news-headline">{parseMarkdown(item.Headline)}</h4>
                    )}
                    
                    {/* Row 3: Content and Thumbnail */}
                    <div className="news-content-wrapper">
                      {item.Content && (
                        <p className="news-content">{parseMarkdown(preventOrphans(item.Content, 6))}</p>
                      )}
                      {thumbnailUrl && (
                        <div className="news-thumbnail-wrapper">
                          <img 
                            src={thumbnailUrl} 
                            alt={item.Headline || 'News thumbnail'} 
                            className="news-thumbnail"
                          />
                          <span className="btn-nav">→</span>
                        </div>
                      )}
                    </div>
                  </>
                );

                // If there's a link, wrap the entire news-item in an anchor
                if (item.Link) {
                  return (
                    <a 
                      key={index}
                      href={item.Link} 
                      className={`news-item has-link ${thumbnailUrl ? 'has-thumbnail' : ''}`}
                    >
                      {newsItemContent}
                    </a>
                  );
                }

                return (
                  <div key={index} className={`news-item ${thumbnailUrl ? 'has-thumbnail' : ''}`}>
                    {newsItemContent}
                  </div>
                );
              })}
            </div>
          ) : (
            <p>No news items available at this time.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewsPage;

